(() => {
  'use strict';
  if (window.archPurchaseInitialized) return;
  window.archPurchaseInitialized = true;
  const mobile = window.matchMedia('(max-width: 767px)');
  const origins = new Map();
  const bound = new WeakSet();
  let queued = false;

  function visible(element) {
    return element && element.getBoundingClientRect().height > 0 &&
      getComputedStyle(element).visibility !== 'hidden' && !element.closest('[hidden]');
  }

  function reviewTarget(link) {
    // These full-review selectors are present in the saved audit, not star badges.
    return [...document.querySelectorAll('#sereni-reviews, #corey-reviews, .yotpo-main-widget, .yotpo-reviews-main-widget')].find((node) => {
      const product = node.closest('[data-yotpo-product-id]');
      return (!product || product.dataset.yotpoProductId === link.dataset.productId) &&
        visible(node) && node.textContent.trim();
    });
  }

  function syncReviewLinks() {
    document.querySelectorAll('[data-arch-review-link]').forEach((link) => {
      const target = reviewTarget(link);
      if (!target) {
        link.removeAttribute('href');
        return;
      }
      if (!target.id) {
        let suffix = 1;
        while (document.getElementById(`arch-product-reviews-${suffix}`)) suffix += 1;
        target.id = `arch-product-reviews-${suffix}`;
      }
      target.setAttribute('data-arch-review-target', '');
      const href = `#${target.id}`;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
  }

  function moveAfter(node, target) {
    if (!mobile.matches || !(node.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
    if (!origins.has(node)) {
      const marker = document.createComment('arch delivery original position');
      node.before(marker);
      origins.set(node, marker);
    }
    target.after(node);
  }

  function moveDelivery(form) {
    const controls = form.querySelector('.product-add-to-cart-container');
    if (!controls || controls.parentElement !== form) return;
    // Preserve the app root, event listeners, tracking, dates and form ownership.
    // The saved DOM proves this direct-child structure; unknown layouts stay put.
    [...form.children].filter((node) => node.matches('.ot-estimated-shipping')).reverse().forEach((node) => {
      moveAfter(node, controls);
    });
  }

  function moveInstallmentDelivery(form) {
    if (!form.querySelector('.ot-estimated-shipping')) return;
    const info = form.closest('[id^="ProductInfo-"]');
    if (!info) return;
    const main = document.getElementById(`product-form-${info.id.slice('ProductInfo-'.length)}`);
    const purchase = main?.closest('product-form');
    if (!main?.matches('form[data-type="add-to-cart-form"]') ||
        !main.querySelector('button[name="add"]') || !purchase ||
        purchase.closest('[id^="ProductInfo-"]') !== info ||
        purchase.parentElement.closest('form') || purchase.contains(form)) return;
    // The live app also mounts in form.installment. Move that entire form,
    // including Shop Pay terms, without moving its app root across form owners.
    moveAfter(form, purchase);
  }

  function mainButton(sticky) {
    return document.getElementById(`product-form-${sticky.dataset.section}`)?.querySelector('button[name="add"]');
  }

  function blocked(button) {
    return !button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading');
  }

  function syncSticky(sticky) {
    const main = mainButton(sticky);
    const proxy = sticky.querySelector('[data-arch-purchase-submit]');
    if (!main || !proxy || !visible(main)) {
      if (sticky.classList.contains('arch-purchase-ready')) sticky.classList.remove('arch-purchase-ready');
      return;
    }
    if (!sticky.classList.contains('arch-purchase-ready')) sticky.classList.add('arch-purchase-ready');
    const label = main.querySelector('span:not(.loading-overlay)')?.textContent.trim() || main.textContent.trim();
    if (proxy.textContent !== label) proxy.textContent = label;
    if (proxy.disabled !== blocked(main)) proxy.disabled = blocked(main);
    if (bound.has(sticky)) return;
    bound.add(sticky);
    proxy.addEventListener('click', () => {
      const current = mainButton(sticky);
      if (!mobile.matches || blocked(current)) return;
      // Invoke the existing submit button, never a second form or cart endpoint.
      current.click();
      syncSticky(sticky);
    });
    sticky.querySelector('[data-arch-purchase-options]').addEventListener('click', () => {
      const current = mainButton(sticky);
      const info = document.getElementById(`ProductInfo-${sticky.dataset.section}`);
      const target = info?.querySelector('variant-selects input:not([type="hidden"]):not(:disabled), variant-selects select:not(:disabled)') || current?.form?.querySelector('[name="quantity"]') || current;
      if (!target) return;
      target.scrollIntoView({ block: 'center', behavior: 'auto' });
      target.focus({ preventScroll: true });
    });
  }

  function refresh() {
    queued = false;
    if (!mobile.matches) {
      origins.forEach((marker, node) => {
        if (node.isConnected && marker.isConnected) marker.after(node);
        marker.remove();
      });
      origins.clear();
    } else {
      origins.forEach((marker, node) => {
        if (!node.isConnected) { marker.remove(); origins.delete(node); }
      });
    }
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(moveDelivery);
    document.querySelectorAll('form.installment').forEach(moveInstallmentDelivery);
    document.querySelectorAll('product-add-to-cart-sticky').forEach(syncSticky);
    syncReviewLinks();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }
  // App hydration and Shopify section replacement can occur after initial load.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  mobile.addEventListener('change', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  // Native cart loading/availability changes are attributes, not child mutations.
  new MutationObserver((records) => {
    if (records.some(({ target }) => target.matches('button[name="add"], .yotpo-main-widget, .yotpo-reviews-main-widget') ||
      target.matches('product-add-to-cart-sticky') ||
      target.querySelector('form[data-type="add-to-cart-form"], .yotpo-main-widget, .yotpo-reviews-main-widget'))) schedule();
  }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'style', 'hidden'] });
  refresh();
})();
